import React, { FunctionComponent } from 'react';
import { InstagramOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNotification } from '../../../hooks/use-notification';
import { useStore } from '../../../helpers/use-store';
import DisabledText from '../disabled-social-text';
import { useTranslation } from 'react-i18next';

interface Props {
  onAccountAdded: () => void;
}

const InstagramAuth: FunctionComponent<Props> = ({ onAccountAdded }) => {
  const { t } = useTranslation();
  const {
    dataStore: { socialAccountStore, userStore },
  } = useStore();
  const notificationApi = useNotification();

  const onSuccess = async (data: { code: string; state: string }) => {
    try {
      const response = await socialAccountStore.instagramAuth(data);

      if (response) {
        notificationApi.success({
          placement: 'top',
          icon: '',
          message: t('common.success'),
          description: t('socialAccounts.instagram.addedSuccess'),
        });

        onAccountAdded();
      } else {
        onError();
      }
    } catch (e) {
      console.error(`failed instagram auth`, e);
    }
  };

  const onError = () => {
    notificationApi.error({
      placement: 'top',
      icon: '',
      message: t('common.error'),
      description: t('socialAccounts.instagram.addError'),
    });
  };

  const handleAuth = async () => {
    const authUrl = await socialAccountStore.getInstagramUrl();

    // Center the popup window
    const width = 500;
    const height = 700;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;

    // Store the callbacks for the popup to use
    window.onInstagramAuthSuccess = onSuccess;
    window.onInstagramAuthError = onError;

    // Open popup
    window.open(
      authUrl.toString(),
      'Instagram Auth',
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`
    );
  };

  const isDisabled = userStore.currentUser.applicationConfig?.disableInstagram;

  return (
    <>
      <Button
        disabled={isDisabled}
        onClick={handleAuth}
        type="primary"
        icon={<InstagramOutlined />}
        block
        style={{
          background: isDisabled
            ? ''
            : 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
          border: 'none',
        }}
      >
        <span style={{ width: '80px' }}>Instagram</span>
      </Button>
      {isDisabled ? <DisabledText /> : null}
    </>
  );
};

export default InstagramAuth;
